// extracted by mini-css-extract-plugin
module.exports = {"Clusterer":"sViGN"};